module.exports = __webpack_public_path__ + "img/52_29.8bc7f80e.png";